/**
 * Account callout never claims “under {{commerceTab}}” on SPI alone — that control
 * lives under Sales points → Prodejní kanály, not on Account.
 */
export type CustomerDirectoryShopOffMessageKind =
  | 'commerce'
  | 'openSalesPoints'
  | 'noEditor';

export function resolveCustomerDirectoryShopOffMessageKind(options: {
  readonly mobileShopEditorAvailableProp: boolean | undefined;
  readonly spiWriteEntitled: boolean;
}): CustomerDirectoryShopOffMessageKind {
  if (options.mobileShopEditorAvailableProp === true) {
    return 'commerce';
  }
  if (options.mobileShopEditorAvailableProp === false) {
    return 'noEditor';
  }
  return options.spiWriteEntitled ? 'openSalesPoints' : 'noEditor';
}
